import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderImageComponent } from './slider-image/slider-image.component';
import { ImgSliderComponent } from './img-slider.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    SliderImageComponent,
    ImgSliderComponent
  ],
  exports: [
    ImgSliderComponent
  ]
})
export class ImgSliderModule { }



// WEBPACK FOOTER //
// ./src/app/pages/home/img-slider/img-slider.module.ts